;(function (angular, _) {
  'use strict'
  angular.module('kilo.routes.dashboard')
    .directive('dashboardCard', DashboardCardDirective)

  DashboardCardDirective.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ]

  function DashboardCardDirective (// Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    return {
      restrict: 'E',
      scope: true,
      bindToController: {
        configuration: '=',
        deleteCard: '&',
        duplicateCard: '&'
      },
      controllerAs: 'ctrl',
      controller: DashboardCardController,
      templateUrl: '/app/modules/dashboard/directives/dashboard-card/dashboard-card.template.html'
    }
  }

  DashboardCardController.$inject = [
    // Angular
    '$filter', '$q', '$state', '$stateParams',
    // Libs
    '$uibModal',
    // Managers
    'DashboardManager', 'InvoiceManager', 'ProductManager', 'QuoteManager', 'BalanceManager', 'CreditNoteManager',
    // Services
    'AggregationService', 'ColorService', 'FilterService', 'PreferencesService', 'CardCreationService'
    // Const
    // Resolved
  ]

  function DashboardCardController (// Angular
    $filter, $q, $state, $stateParams,
    // Libs
    $uibModal,
    // Managers
    DashboardManager, InvoiceManager, ProductManager, QuoteManager, BalanceManager, CreditNoteManager,
    // Services
    AggregationService, ColorService, FilterService, PreferencesService, CardCreationService
    // Const
    // Resolved
  ) {
    var self = this
    var defaultQuery = {
      invoice: {
        populate: JSON.stringify([
          {
            path: 'client',
            select: '__t type number label'
          },
          {
            path: 'tags',
            select: 'color label'
          }
        ]),
        select: 'number reference title client date dueDate status tags total computed discountedTotal type totalVAT balanceDue balancePaid fullTotal isArchived lines payments createdAt'
      },
      balance: {
        populate: JSON.stringify([
          {
            path: 'client',
            select: '__t type number label'
          }
        ])
      },
      product: {},
      quote: {
        populate: JSON.stringify([
          {
            path: 'client',
            select: '__t type number label'
          },
          {
            path: 'tags',
            select: 'color label'
          }
        ]),
        select: 'number reference title client date dueDate signDate status tags total computed discountedTotal fullTotal isArchived totalVAT lines createdAt'
      },
      creditnote: {
        populate: JSON.stringify([
          {
            path: 'client',
            select: '__t type number label'
          },
          {
            path: 'tags',
            select: 'color label'
          }
        ]),
        select: 'number reference title client date dueDate status tags total fullTotal isArchived totalVAT lines invoiceRef createdAt'
      }
    }
    var graphConfiguration = {
      layout: {
        padding: {
          left: 0,
          right: 10,
          top: 10,
          bottom: 10
        }
      },
      scales: {
        yAxes: [
          {
            scaleLabel: {
              display: true,
              labelString: $filter('cardConcern')(_.get(self, 'configuration.concern'))
            },
            ticks: {
              callback: function (label, index, labels) {
                if (self.configuration.type === 'financial') {
                  return $filter('numeral')(label)
                }
                return label
              },
              beginAtZero: true
            }
          }
        ],
        xAxes: [
          {
            display: false, // TMP ISSUE ON CHARTJS https://github.com/chartjs/Chart.js/issues/3694
            scaleLabel: {
              display: true,
              labelString: $filter('graphAxis')(_.get(self, 'configuration.groupBy.value'))
            }
          }
        ]
      },
      maintainAspectRatio: false,
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            if (self.configuration.type === 'financial') {
              return $filter('numeral')(data.datasets[0].data[tooltipItem.index])
            }
            return data.datasets[0].data[tooltipItem.index]
          },
          title: function (tooltipItem, data) {
            if (_.get(tooltipItem, [0, 'xLabel']) === 'null' || _.get(tooltipItem, [0, 'xLabel']) === 'undefined') {
              return 'Non spécifié'
            }
            return $filter('ellipsis')(_.get(tooltipItem, [0, 'xLabel']))
          }
        }
      }
    }
    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        graphConfiguration: graphConfiguration,
        // Public Methods
        gotToList: gotToList,
        promptMove: promptMove,
        showDetail: showDetail,
        editCard: editCard,
        query: query
      })

      init()
      if (self.configuration.display.type === 'circular') {
        self.graphConfiguration = {
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                if (self.configuration.type === 'financial') {
                  return ($filter('ellipsis')(data.labels[tooltipItem.index], 10)) + ' : ' + $filter('numeral')(data.datasets[0].data[tooltipItem.index])
                } else {
                  return $filter('ellipsis')(data.labels[tooltipItem.index], 10) + ' : ' + data.datasets[0].data[tooltipItem.index]
                }
              }
            }
          }
        }
      }
    }

    function init () {
      self.textColor = blackOrWhite()
      var count = !(self.configuration.concern === 'balance' && self.configuration.type !== 'financial')
      query(count).then(function (data) {
        if (self.configuration.display.type === 'number') {
          if (self.configuration.type === 'financial') {
            if (self.configuration.concern !== 'balance') {
              self.countNumber = _.get(data, ['data', 0, 'totalNumber'], 0)
            }
            self.count = $filter('numeral')(_.get(data, ['data', 0, 'total'], 0))
          } else {
            self.count = data.data
          }
        } else {
          self.data = []
          self.labels = []
          _.each(data.data, function (entry) {
            self.data.push(entry.total)
            if (self.configuration.groupBy.value === 'status') {
              entry._id = $filter('status')(self.configuration.concern, entry._id)
            }
            self.labels.push(entry._id)
          })
          if (data.data.length === 0) {
            self.labels = ['0']
            self.data = ['Aucune donnée']
          }
        }
      })
    }

    function blackOrWhite () {
      return ColorService.getLuminance(self.configuration.color) < 200 ? '#FFFFFF' : '#000000'
    }

    function query (count) {
      var manager
      switch (self.configuration.concern) {
        case 'balance':
          manager = BalanceManager
          break
        case 'invoice':
        case 'deposit':
          manager = InvoiceManager
          break
        case 'product':
          manager = ProductManager
          break
        case 'quote':
          manager = QuoteManager
          break
        case 'creditnote':
          manager = CreditNoteManager
          break
      }
      if (!manager) {
        return $q.reject()
      }
      self.configuration.query = FilterService.sanitizeSearchTree(self.configuration.query, true)
      var query = manager.query(_.cloneDeep(defaultQuery[self.configuration.concern])).archived(String(FilterService.hasArchivedCriteria(self.configuration.query, true)))
      if (_.isEmpty(self.configuration.query)) {
        self.configuration.query = FilterService.addCriteria(self.configuration.query, 'isArchived', {
          _id: 'archived',
          value: 'false'
        })
        return self.query(count)
      }

      if (self.configuration.query) {
        query.setQuery(FilterService.parseQueryTree(self.configuration.query))
      }
      query.paginate({limit: 10})

      if (['quote', 'invoice', 'deposit'].includes(self.configuration.concern)) {
        if (query.opts.conditions.$and) {
          query.opts.conditions.$and.push({ isModel: { $exists: false } })
        } else {
          query.opts.conditions = { $and: [
            { isModel: { $exists: false } }
          ] }
        }
        if (self.configuration.concern === 'invoice') {
          query.opts.conditions.$and.push({ type: 'invoice' })
        } else if (self.configuration.concern === 'deposit') {
          query.opts.conditions.$and.push({ type: 'deposit' })
        }
      }
      query.opts.count = !!count
      if (self.configuration.display.type !== 'number' && query.opts.count) {
        var q = manager.query({
          aggregate: JSON.parse(JSON.stringify(AggregationService.aggregate(self.configuration.groupBy.value, self.configuration.type, self.configuration.concern, _.get(self.configuration, 'display.configuration'))))
        })
        q.opts.conditions = query.opts.conditions
        return manager.aggregate(q, {ignoreArchived: true})
      }

      if (self.configuration.type === 'financial' && query.opts.count) {
        var q = manager.query({
          aggregate: JSON.parse(JSON.stringify(AggregationService.simpleFinancial(self.configuration.concern)))
        })
        q.opts.conditions = query.opts.conditions
        if (query.opts.archived) {
          q.opts.archived = query.opts.archived
        }
        return manager.aggregate(q, {ignoreArchived: true})
      }

      return manager.post(query, {ignoreArchived: true})
    }

    function showDetail () {
      if (self.configuration.concern === 'balance') return
      return $uibModal.open({
        size: 'lg',
        templateUrl: '/app/modules/dashboard/modals/card-detail-modal.template.html',
        resolve: {
          data: [function () {
            return query(false)
          }],
          concern: [function () {
            return angular.copy(self.configuration.concern)
          }],
          configuration: [function () {
            return self.configuration
          }],
          preferences: ['UtilService', function (UtilService) {
            return UtilService.isLoaded
          }]
        },
        controller: 'CardDetailModalController',
        controllerAs: 'ctrl'
      }).result.then(gotToList)
    }

    function gotToList () {
      let concern = angular.copy(self.configuration.concern)
      if (['balance', 'deposit'].includes(concern)) {
        if (concern === 'deposit') {
          if (self.configuration.query['__AND']) {
            self.configuration.query['__AND'].push({ criteria: { label: 'Acompte', v: 'deposit', _id: 'type' }, key: 'type' })
          } else {
            self.configuration.query = { '__AND': [self.configuration.query, { criteria: { label: 'Acompte', v: 'deposit', _id: 'type' }, key: 'type' }] }
          }
        }
        concern = 'invoice'
      } else if (concern === 'invoice') {
        if (self.configuration.query['__AND']) {
          self.configuration.query['__AND'].push({ criteria: { label: 'Globale', v: 'invoice', _id: 'type' }, key: 'type' })
        } else {
          self.configuration.query = { '__AND': [self.configuration.query, { criteria: { label: 'Globale', v: 'invoice', _id: 'type' }, key: 'type' }] }
        }
      }
      $state.go(concern + '.list', { linkedSearch: self.configuration.query })
    }

    function editCard () {
      CardCreationService.configureCard(angular.copy(self.configuration)).then(function (card) {
        card.save().then(function () {
          $state.reload()
        })
      })
    }

    function promptMove () {
      $uibModal.open({
        templateUrl: '/app/modules/dashboard/modals/move.template.html',
        controller: 'DashboardMoveModalController',
        controllerAs: 'ctrl',
        size: 'lg',
        resolve: {
          card: [function () {
            return self.configuration
          }],
          dashboards: ['$sessionStorage', 'DashboardManager', function ($sessionStorage, DashboardManager) {
            var company = $sessionStorage.company
            var user = $sessionStorage.user
            var query = DashboardManager
              .query()
              .select(company, 'company')
              .select(user, 'user')

            return DashboardManager.get(query).then(function (data) {
              self.dashboards = data
              return data
            })
          }]
        }
      }).result.then(function (dest) {
        // Get destination dashboard as Dashboard object and push card
        var destDashboard = DashboardManager.create(_.find(self.dashboards.data, function (d) {
          return d._id === dest
        }))
        destDashboard.cards.push(self.configuration._id)
        destDashboard.save().then(function () {
          var currentDashboard

          // Get current Dashboard, remove card from it then reload state
          if ($stateParams.current) {
            currentDashboard = _.find(self.dashboards.data, {_id: $stateParams.current}) || self.dashboards.data[0]
            currentDashboard = DashboardManager.create(currentDashboard)
            _.remove(currentDashboard.cards, function (c) {
              return c === self.configuration._id
            })
            currentDashboard.save().then(function () {
              $state.reload()
            })
          } else {
            PreferencesService.getGeneralPrefs().then(function (pref) {
              currentDashboard = _.find(self.dashboards, {_id: _.get(pref, 'settings.dashboard.default')}) || self.dashboards[0]
              currentDashboard = DashboardManager.create(currentDashboard)
              _.remove(currentDashboard.cards, function (c) {
                return c === self.configuration._id
              })
              currentDashboard.save().then(function () {
                $state.reload()
              })
            })
          }
        })
      })
    }
  }
})(window.angular, window._)
